import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { api } from "../api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

function seen(p) {
  try {
    const k = `qora_promo_${p.id}`;
    const v = localStorage.getItem(k);
    if (p.frequency_type === "every_visit") return false;
    if (p.frequency_type === "session") return sessionStorage.getItem(k) === "1";
    if (p.frequency_type === "days") {
      if (!v) return false;
      const days = (Date.now() - parseInt(v, 10)) / 86400000;
      return days < (p.frequency_days || 1);
    }
    return false;
  } catch { return false; }
}
function markSeen(p) {
  try {
    const k = `qora_promo_${p.id}`;
    if (p.frequency_type === "session") sessionStorage.setItem(k, "1");
    else localStorage.setItem(k, String(Date.now()));
  } catch {}
}
const track = (id, kind) => { try { const fd = new FormData(); fd.append("kind", kind); fetch(`${BACKEND}/api/public/promotions/${id}/event`, { method: "POST", body: fd }); } catch {} };

export default function PromoPopup({ pageSlug, menuId }) {
  const [promos, setPromos] = useState([]);
  const [show, setShow] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.publicPromotions(pageSlug ? { page_slug: pageSlug } : { menu_id: menuId });
        setPromos(data);
        const popup = data.filter((p) => p.display_mode === "popup" && !seen(p)).sort((a, b) => b.priority - a.priority)[0];
        if (popup) {
          const t = setTimeout(() => { setShow(popup); track(popup.id, "view"); markSeen(popup); }, (popup.delay_seconds || 0) * 1000);
          return () => clearTimeout(t);
        }
      } catch {}
    })();
  }, [pageSlug, menuId]);

  const click = (p) => { track(p.id, "click"); let u = p.button_url; if (u && u.startsWith("/")) u = window.location.origin + u; if (u) window.open(u, "_blank"); };
  const banners = promos.filter((p) => p.display_mode === "banner").sort((a, b) => b.priority - a.priority).slice(0, 1);

  return (
    <>
      {banners.map((b) => (
        <div key={b.id} className="btn-grad text-white px-4 py-2.5 text-sm text-center flex items-center justify-center gap-3">
          <span className="font-medium">{b.title}{b.text ? ` — ${b.text}` : ""}</span>
          {b.button_label && b.button_url && <button onClick={() => click(b)} className="underline font-semibold">{b.button_label}</button>}
        </div>
      ))}

      {show && (
        <div className="fixed inset-0 z-[100] grid place-items-center p-4" role="dialog" aria-modal="true">
          <div className="absolute inset-0 bg-black/50" onClick={() => setShow(null)} />
          <div className="relative w-full max-w-sm rounded-2xl bg-white overflow-hidden shadow-2xl">
            <button onClick={() => setShow(null)} aria-label="Chiudi" className="absolute top-2 right-2 z-10 h-8 w-8 grid place-items-center rounded-full bg-black/30 text-white hover:bg-black/50"><X className="h-4 w-4" /></button>
            {show.image && <img src={show.image.startsWith("http") ? show.image : api.mediaUrl(show.image)} alt="" className="w-full aspect-video object-cover" />}
            <div className="p-5 text-center">
              <h3 className="font-display text-lg font-extrabold">{show.title}</h3>
              {show.text && <p className="text-sm text-muted-foreground mt-2">{show.text}</p>}
              {show.button_label && show.button_url && (
                <button onClick={() => { click(show); setShow(null); }} className="btn-grad text-white font-semibold rounded-xl px-5 py-2.5 mt-4 w-full">{show.button_label}</button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
